import { render } from "./DatosPersonales.vue?vue&type=template&id=5749d769&scoped=true"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"

import "./DatosPersonales.vue?vue&type=style&index=0&id=5749d769&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5749d769"]])

export default __exports__